export default __webpack_public_path__ + "static/media/real_estate_web-lg@1x.a22bcb26.webp";